import { createSlice } from "@reduxjs/toolkit"
import { omit } from "ramda"
import type { WritableDraft } from "immer/dist/types/types-external.d.ts"

export interface UserProfileProps {
  user: any
}

type BaseGlobalProps = {
  data: any
  list: Record<string, unknown>
  loading: boolean | null
  authIsReady: boolean
}
export interface GlobalProps {
  global: BaseGlobalProps & UserProfileProps
}

export const initialState: BaseGlobalProps & UserProfileProps = {
  user: { profileTheme: localStorage.getItem("mode") || "light" },
  data: {},
  list: {},
  loading: null,
  authIsReady: false,
}

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    isLoggedIn: (state, { payload }) => {
      state.user = payload?.data
        ? payload.data
        : { ...state.user, initialState }
      state.authIsReady = payload?.data?.email ? true : false
      state.loading = payload?.data?.email ? false : null
    },
    logOut: (state) => {
      state.user = initialState.user
      state.data = initialState.data
      state.list = initialState.list
      state.loading = initialState.loading
      state.authIsReady = initialState.authIsReady
    },
    setUser: (state, { payload }) => {
      state.user = payload
      state.loading = false
    },
    updateUserState: (state, { payload }) => {
      state.user = { ...state.user, ...payload.data }
      state.loading = false
    },
    authReady: (state, { payload }) => {
      state.user = payload.data
      state.authIsReady = true
    },
    saveFn: (state, { payload }) => {
      state.data = { ...state.data, ...payload }
      state.loading = payload?.loading || false
    },
    deleteFn: (state, { payload }) => {
      state.data = omit([payload], state.data)
      state.loading = false
    },
    setList: (state: WritableDraft<Record<string, any>>, { payload }) => {
      //can set any list specified in payload inside the global.list object
      const { list, id, data } = payload
      if (list && data && state.list[list] && id !== 0) {
        state.list[list] = [...state.list[list], ...data]
      } else if (list) {
        state.list[list] = data
      }
    },
    deleteList: (state, { payload }) => {
      state.list = omit([payload], state.list)
    },
    setIsLoading: (state, { payload }) => {
      state.loading = payload || false
    },
  },
  // extraReducers: (builder) => {
  //  builder.addCase(isLoggedIn, (state, { payload }) => {})
  //   },
})

export const {
  isLoggedIn,
  logOut,
  authReady,
  setUser,
  updateUserState,
  saveFn,
  deleteFn,
  setList,
  deleteList,
  setIsLoading,
} = globalSlice.actions

export const selectGlobalState = (state: GlobalProps) => state.global
export const selectUserProfile = (state: GlobalProps) => state.global.user

export default globalSlice.reducer

// Thunk action
// export const fetchUser = (userId) => async (dispatch) => {
//   try {
//     const response = await api.getUser(userId); // Your API function
//     dispatch(userSlice.actions.userFetched(response.data));
//   } catch (error) {
//     // Handle error if needed
//   }
// };
